import m from "./ghl-ui.es1589.js";
import p from "./ghl-ui.es1590.js";
import s from "./ghl-ui.es1586.js";
import c from "./ghl-ui.es1587.js";
import f from "./ghl-ui.es1588.js";
import n from "./ghl-ui.es1591.js";
import { Parser as l } from "./ghl-ui.es1670.js";
import { numericPatterns as h } from "./ghl-ui.es1672.js";
import { parseNDigits as v, parseNumericPattern as P } from "./ghl-ui.es1671.js";
var k = /* @__PURE__ */ function(u) {
  c(a, u);
  var i = f(a);
  function a() {
    var o;
    m(this, a);
    for (var r = arguments.length, t = new Array(r), e = 0; e < r; e++)
      t[e] = arguments[e];
    return o = i.call.apply(i, [this].concat(t)), n(s(o), "priority", 70), n(s(o), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), o;
  }
  return p(a, [{
    key: "parse",
    value: function(r, t, e) {
      switch (t) {
        case "H":
          return P(h.hour23h, r);
        case "Ho":
          return e.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return v(t.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, t) {
      return t >= 0 && t <= 23;
    }
  }, {
    key: "set",
    value: function(r, t, e) {
      return r.setUTCHours(e, 0, 0, 0), r;
    }
  }]), a;
}(l);
export {
  k as Hour0to23Parser
};
